
 <!-- <div class="content-wrapper pt-2"> -->
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Guest</div> 
      <form  [formGroup] ="addCustomerForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="form-group row">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

        <div class="form-group row">
          <label for="guestId" class="col-md-2 col-form-label">ID</label>  
          <div class="col-md-8">
          <div class="input-group">
            <div class="input-group-prepend">
          <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
          </div>
          <input  name="guestId" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="guestId" placeholder="Guest Id"  class="form-control field-bg-color" [class.is-invalid]="formErrors.guestId" (blur)="logValidationErrors()"   type="text">
            </div>
            <span class="text-danger" *ngIf="formErrors.guestId"><small>{{formErrors.guestId}}</small> </span>   
          </div>
          </div>

          <div class="form-group row">
            <label for="guestName" class="col-md-2 col-form-label ">Name</label>  
            <div class="col-md-8">
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <input  name="guestName" [ngClass]="{'dark-input-field' : isDark }" formControlName="guestName" placeholder="Guest Name"  class="form-control" [class.is-invalid]="formErrors.guestName" (blur)="logValidationErrors()" type="text">   
              </div>
              <span class="text-danger" *ngIf="formErrors.guestName"><small>{{formErrors.guestName}}</small> </span>   
            </div>
            </div>

            

            <div class="form-group row">
              <label for="address" class="col-md-2 col-form-label ">Address</label>  
              <div class="col-md-8">
              <div class="input-group">
                <div class="input-group-prepend">
              <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
              </div>
              <textarea name="address"  [ngClass]="{'dark-input-field' : isDark }" formControlName="address" placeholder="Address" class="form-control" [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()"  rows="3"></textarea>
                </div>
                <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
              </div>
              </div>

              <div class="form-group row">
                <label for="nic" class="col-md-2 col-form-label ">NIC</label>  
                <div class="col-md-3">    
                <div class="input-group">
                  <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                </div>
                <input  name="nic" [ngClass]="{'dark-input-field' : isDark }" formControlName="nic" placeholder="NIC" class="form-control"  type="text">
              </div>
                </div>
              
                 <label for="country" class="col-md-2 col-form-label">Country</label>
                    <div class="col-md-3">                  
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                      </div>
                      <select [ngClass]="{'dark-input-field' : isDark }" formControlName="country" class="form-control field-bg-color"   [class.is-invalid]="formErrors.country" (blur)="logValidationErrors()">        
                        <option [ngValue]="null">-Select-</option>
                        <option *ngFor="let item of countryList" [value]="item.value">
                          {{item.value}}
                        </option>
                    </select>
                    </div>
                    <span class="text-danger" *ngIf="formErrors.country"><small>{{formErrors.country}}</small> </span>   
                  </div>
                </div>

                <div class="form-group row">
                  <label for="gender" class="col-md-2  col-form-label">Gender</label>
                  <div class="col-md-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                    </div>
                    <select [ngClass]="{'dark-input-field' : isDark }" formControlName="gender" class="form-control field-bg-color">        
                      <option [ngValue]="null">-Select-</option>
                      <option *ngFor="let item of genderList" [value]="item.value">
                        {{item.value}}
                      </option>
                  </select>
                  </div>
                </div>
            

                  <label for="dob" class="col-md-2 col-form-label ">DOB</label>  
                  <div class="col-md-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                      </div>
                      <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="dob" class="form-control field-bg-color"  placeholder="DOB">
                    </div>
                </div>
                </div>
  
                  <div class="form-group row">
                    <label for="phone" class="col-md-2 col-form-label ">Phone</label>  
                    <div class="col-md-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-phone"></i></span>
                    </div>
                    <input  name="phone" [ngClass]="{'dark-input-field' : isDark }" formControlName="phone" placeholder="Phone Number"  class="form-control" [class.is-invalid]="formErrors.phone" (blur)="logValidationErrors()"  type="text">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.phone"><small>{{formErrors.phone}}</small> </span>   
                  </div>
                  </div>

                      <div class="form-group row">
                        <label for="email" class="col-md-2 col-form-label ">Email</label>  
                        <div class="col-md-8">
                        <div class="input-group">
                          <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                        </div>
                        <input  name="email" [ngClass]="{'dark-input-field' : isDark }" formControlName="email" placeholder="Email" id="email" class="form-control" [class.is-invalid]="formErrors.email" (blur)="logValidationErrors()"  type="text">
                      </div>
                      <span class="text-danger" *ngIf="formErrors.email"><small>{{formErrors.email}}</small> </span>   
                        </div>
                        </div>

                        <div class="form-group row">
                          <label for="bookingSource" class="col-md-2 col-form-label">Booking Source</label>
                          <div class="col-md-3">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                            </div>
                            <select [ngClass]="{'dark-input-field' : isDark }" formControlName="bookingSource" class="form-control field-bg-color"   [class.is-invalid]="formErrors.bookingSource" (blur)="logValidationErrors()">        
                              <option [ngValue]="null">-Select-</option>
                              <option *ngFor="let item of bookingSourceList" [value]="item.value">
                                {{item.value}}
                              </option>
                          </select>
                          </div>
                          <span class="text-danger" *ngIf="formErrors.bookingSource"><small>{{formErrors.bookingSource}}</small> </span>   
                        </div>
        
                        <label for="roomType" class="col-md-2 col-form-label">Room Type</label>
                        <div class="col-md-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                          </div>
                          <select [ngClass]="{'dark-input-field' : isDark }" formControlName="roomType" class="form-control field-bg-color">        
                            <option [ngValue]="null">-Select-</option>
                            <option *ngFor="let item of roomTypeList" [value]="item.value">
                              {{item.value}}
                            </option>
                        </select>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="package" class="col-md-2 col-form-label ">Package</label>  
                      <div class="col-md-8">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cube"></i></span>
                          </div>
                          <select [ngClass]="{'dark-input-field' : isDark }" formControlName="package" class="form-control field-bg-color">        
                            <option [ngValue]="null">-Select-</option>
                            <option *ngFor="let item of packageList" [value]="item.value">
                              {{item.value}}
                            </option>
                        </select>
                        </div>
                      </div>
                    </div>


                    <div class="form-group row">
                      <label for="roomNo" class="col-md-2 col-form-label ">Room No</label>  
                      <div class="col-md-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                      </div>
                      <select [ngClass]="{'dark-input-field' : isDark }" formControlName="roomNo" class="form-control field-bg-color">        
                        <option [ngValue]="null">-Select-</option>
                        <option *ngFor="let item of roomNoList" [value]="item.value">
                          {{item.value}}
                        </option>
                      </select>
                      </div>
                      </div>

                      <label for="roomExtNo" class="col-md-2 col-form-label ">Room Ext. No</label>  
                      <div class="col-md-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                      </div>
                      <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="roomExtNo" placeholder="Room Ext.No" class="form-control"  type="text">
                      </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="checkedIn" class="col-md-2 col-form-label ">Checked In</label>  
                      <div class="col-md-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                          </div>
                          <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker   placement="top" [bsConfig]="datepickerConfig" formControlName="checkedIn" class="form-control field-bg-color" [class.is-invalid]="formErrors.checkedIn" (blur)="logValidationErrors()"  placeholder="Checked In">
                        </div>
                        <span class="text-danger" *ngIf="formErrors.checkedIn"><small>{{formErrors.checkedIn}}</small> </span>  
                    </div>
                            
                      <label for="checkedOut" class="col-md-2 col-form-label ">Checked Out</label>  
                      <div class="col-md-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                          </div>
                          <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker   placement="top" [bsConfig]="datepickerConfig" formControlName="checkedOut" class="form-control field-bg-color"  placeholder="Checked Out">
                        </div>
                    </div>
                    </div>

                    <div class="form-group row">
                      <label for="advance" class="col-md-2 col-form-label ">Advance</label>  
                      <div class="col-md-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-money"></i></span>
                      </div>
                      <input   [ngClass]="{'dark-input-field' : isDark }" formControlName="advance" placeholder="Advance" class="form-control"  type="text">
                      </div>
                      </div>

                      <label for="depositAccount" class="col-md-2 col-form-label ">Deposit Account</label>  
                      <div class="col-md-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                      </div>
                      <select [ngClass]="{'dark-input-field' : isDark }" formControlName="depositAccount" class="form-control field-bg-color">        
                        <option [ngValue]="null">-Select-</option>
                        <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                          {{item.AccountName}}
                        </option>
                      </select>
                      </div>
                      </div>           
                    </div>

                    <div class="form-group row">
                      <div class="col-md-2"></div>
                      <div class="col-md-8">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" name="status" formControlName="status"  id="status">
                          <label class="form-check-label" for="status">
                            Deactivated
                          </label>
                        </div>
                      </div>
                    </div>  

      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-primary ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../customer-list"><i class="fa fa-table p-1"></i>Guest List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
    <!-- </div> -->


    <!-- Form Values : {{ addCustomerForm.value | json }} -->
  
